import { render } from "./SendMessageDialog.vue?vue&type=template&id=5391ca84&ts=true"
import script from "./SendMessageDialog.ts?vue&type=script&lang=ts"
export * from "./SendMessageDialog.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__